import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  ViewChild,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  ElementRef
} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { FlatpickrDirective, provideFlatpickrDefaults } from 'angularx-flatpickr';
import { getFlatpickrDefaults } from '../flatpickr-defaults';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ApiCallsService } from '../../services/api-calls.service';
import { AgGridTableService } from '../../services/ag-grid.service';
import { ToastService } from '../../services/toast.service';
import { ActivatedRoute } from '@angular/router';
import { ScrollingModule } from '@angular/cdk/scrolling';
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect';
import { SiteSearchService } from '../../services/site-search.service';
import { Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface DropdownItem {
  site_id: string;
  site_name: string;
  selected: boolean;
}

export interface LocationItem {
  id: string;
  location_no: string;
}

export interface TowerItem {
  id: string;
  name: string;
}

@Component({
  selector: 'app-filter-select',
  standalone: true,
  imports: [FlatpickrDirective, CommonModule, FormsModule, NgbModule, ScrollingModule],
  templateUrl: './filter-select.component.html',
  styleUrl: './filter-select.component.scss',
  providers: [provideFlatpickrDefaults(getFlatpickrDefaults())],
})
export class FilterSelectComponent implements OnInit, OnDestroy, OnChanges {
  // ===============================
  // INPUTS — Visibility & Mode Toggles
  // ===============================
  @Input() header: string | null = '';
  @Input() reports: boolean = false;
  @Input() consumer: boolean = false;

  // Site toggles
  @Input() showSites: boolean = false;
  @Input() SiteOnly: boolean = false;
  @Input() showLocation: boolean = true;
  @Input() MultiSites: boolean = false;
  @Input() AllSites: boolean = true;
  @Input() AllSelection: boolean = true;

  // Tower toggle
  @Input() towerSelect: boolean = false;
  @Input() towerlist: boolean = false;

  get isTowerSelect(): boolean {
    return this.towerSelect || this.towerlist;
  }

  // Location toggles
  @Input() FromToLocation: boolean = false;
  @Input() ShowLocationDropdown: boolean = false;
  @Input() SingleLocationDropdown: boolean = false;
  @Input() Nolocation: boolean = false;
  @Input() locationId: boolean = false;

  // Date / Time toggles
  @Input() showDaterange: boolean = true;
  @Input() showSingleDate: boolean = false;
  @Input() Date_Flat: boolean = false;
  @Input() Date_Time: boolean = false;
  @Input() DateTimerange: boolean = false;
  @Input() Date_time: boolean = false;
  @Input() Month_Year: boolean = false;
  @Input() Month_Range: boolean = false;
  @Input() timeDuration: number = 0;
  @Input() selectedfiltersType: string = 'Date Wise';

  // Appliance / Subtype / Modifiers
  @Input() showappliances: boolean = false;
  @Input() showsubtype: boolean = false;
  @Input() showBillNo: boolean = false;
  @Input() Hours: boolean = false;
  @Input() search: boolean = false;
  @Input() dropdown: boolean = false;
  @Input() dropdownOptions: any;
  @Input() placeholder: any;
  @Input() InputField: boolean = false;
  @Input() InputFields: any[] = [];

  // Dynamic filterConfig persistent selection map
  dynamicSelectedMap: { [apiKey: string]: { value: any; label: string; option: any } } = {};

  // Dynamic filterConfig
  @Input() filterConfig: any[] = [];

  // ===============================
  // OUTPUTS
  // ===============================
  @Output() filtersApplied = new EventEmitter<any>();
  @Output() showTable = new EventEmitter<boolean>();
  @Output() consumerListing = new EventEmitter<{ filter: string; id: string }>();

  // ===============================
  // VIEW REFS
  // ===============================
  @ViewChild(FlatpickrDirective) flatpickr!: FlatpickrDirective;

  // ===============================
  // STATIC CONSTANTS & PLUGINS
  // ===============================
  hours = Array.from({ length: 40 }, (_, i) => String(i + 1).padStart(2, '0'));
  monthPlugins = [
    monthSelectPlugin({ shorthand: false, dateFormat: 'Y-m', altFormat: 'F Y', theme: 'light' })
  ];
  DateFlatArray: any[] = [{ value: 'Date Wise' }, { value: 'Flat Wise' }];
  shimmerArray = Array(10);
  today = new Date();
  minDate: any = this.resolveMinDate();
  readonly dropdownButtonText: string = 'Selected Sites';

  // ===============================
  // AUTH / SESSION STATE
  // ===============================
  loginType: string | null = localStorage.getItem('login_Type');
  dropdownItems: string | null = JSON.parse(sessionStorage.getItem('tableItems') || '[]');
  siteid: string | null = null;
  lockedSiteName: string = '';

  // ===============================
  // ===============================
  // SITE SELECTION STATE
  // ===============================
  basicdropdownitem: DropdownItem[] = [];
  selectedSite: any = null;
  searchTerm: string = '';
  siteloading: boolean = false;

  // ===============================
  // TOWER STATE
  // ===============================
  towerList: TowerItem[] = [];
  selectedTower: TowerItem | null = null;
  towerSearchTerm: string = '';

  // ===============================
  // LOCATION STATE
  // ===============================
  selectedLocation: LocationItem | null = null;
  selectedLocationFrom: LocationItem | null = null;
  selectedLocationTo: LocationItem | null = null;
  locationFrom: string = '';
  locationTo: string = '';
  locationSingle: string = '';
  ConsumerLocationId: string = '';
  locationNo: string = '';
  selectedType: string = 'location_no';

  selectedLocationIds: LocationItem[] = [];
  selectedLocationIdsFrom: LocationItem[] = [];
  selectedLocationIdsTo: LocationItem[] = [];
  locationSearchTerm: string = '';
  locationSearchTermFrom: string = '';
  locationSearchTermTo: string = '';

  // ===============================
  // APPLIANCE STATE
  // ===============================
  selectedAppliances: any[] = [];
  selectedItemAppliance: string = '';
  selectedApplianceId: string = '';

  // ===============================
  // GENERIC DROPDOWN & SUBTYPES
  // ===============================
  dropdownKey: string = '';
  dropdownList: any[] = [];
  dropdownRequired: boolean = false;
  selectedDropdown: any = null;
  selectedItem: string = '';
  selectedItemId: string = '';
  BillingItem: string = '';
  BillingItemId: string = '';
  selectedHours: string | null = null;
  searchText: string = '';

  subtype: any = { class: 'btn-white text-black', title: 'Type', item: [] };
  Billingno: any = {
    class: 'btn-white text-black',
    title: 'Show Billing No',
    item: [
      { id: 'Y', name: 'Yes' },
      { id: 'N', name: 'No' }
    ]
  };

  // ===============================
  // DATE / TIME STATE
  // ===============================
  dateRange: string | Date[] = '';
  formattedFromDate: string = '';
  formattedToDate: string = '';
  selectedDate: Date | string = '';
  formattedDate: string = '';
  fromDateTime!: Date | string;
  toDateTime!: Date | string;

  private unitidsubs?: Subscription;
  private queryParamsSubs?: Subscription;

  constructor(
    private readonly apiservice: ApiCallsService,
    private readonly aggrid: AgGridTableService,
    private readonly toast: ToastService,
    private readonly route: ActivatedRoute,
    private readonly UnitId: SiteSearchService,
    private readonly http: HttpClient,
    private readonly el: ElementRef,
  ) { }

  // ===============================
  // LIFECYCLE
  // ===============================
  ngOnInit(): void {
    this.clearInputFields();
    setTimeout(() => this.clearInputFields(), 0);
    setTimeout(() => this.clearInputFields(), 150);
    setTimeout(() => this.clearInputFields(), 300);

    this.showTable.emit(false);
    this.today.setHours(23, 59, 59, 999);
    this.minDate = this.resolveMinDate();

    if (this.Hours) {
      this.selectedHours = this.hours[0];
    }

    this.unitidsubs = this.UnitId.shortCode$.subscribe(res => {
      this.locationNo = res || '';
      if (this.consumer && this.locationNo) {
        this.applyFilters();
      }
    });

    this.queryParamsSubs = this.route.queryParams.subscribe(() => {
      this.resolveSiteContext();
      this.minDate = this.resolveMinDate();
    });

    this.configureGenericDropdown();
    this.resolveSiteContext();
    this.configureSubtypeOptions();
    this.loadInitialSiteData();
    this.loadDynamicFilterOptions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filterConfig'] && !changes['filterConfig'].firstChange && this.filterConfig?.length) {
      this.loadDynamicFilterOptions();
    }
  }

  ngOnDestroy(): void {
    this.showTable.emit(false);
    this.unitidsubs?.unsubscribe();
    this.queryParamsSubs?.unsubscribe();
  }

  clearInputFields(): void {
    this.searchText = '';
    this.searchTerm = '';
    this.towerSearchTerm = '';
    this.locationSearchTerm = '';
    this.locationSearchTermFrom = '';
    this.locationSearchTermTo = '';
    if (Array.isArray(this.filterConfig)) {
      this.filterConfig.forEach(f => {
        if (f.type === 'text') {
          f.value = '';
        }
        if (f.searchTerm !== undefined) {
          f.searchTerm = '';
        }
      });
    }

    try {
      const nativeEl = this.el?.nativeElement;
      if (nativeEl) {
        const inputs = nativeEl.querySelectorAll('input[type="text"]');
        inputs.forEach((input: HTMLInputElement) => {
          if (!input.classList.contains('flatpickr-input') && !input.classList.contains('datepicker')) {
            input.value = '';
            input.dispatchEvent(new Event('input', { bubbles: true }));
          }
        });
      }
    } catch {
      // safe fallback
    }
  }

  // ===============================
  // DECLARATIVE COMPUTED GETTERS
  // ===============================
  get isSingleSite(): boolean {
    return !!this.siteid && this.siteid !== 'ALL' && this.siteid !== 'all';
  }

  get shouldShowLockedSite(): boolean {
    return this.isSingleSite && this.loginType !== 'CO';
  }

  get shouldShowSingleSiteSelect(): boolean {
    if (this.isSingleSite || this.loginType === 'CO') return false;
    if (this.MultiSites) return false;
    return this.showSites || this.SiteOnly || (!this.showLocation && !this.FromToLocation);
  }

  get shouldShowMultiSiteSelect(): boolean {
    if (this.isSingleSite || this.loginType === 'CO') return false;
    return this.MultiSites || (this.showLocation && !this.SiteOnly && !this.showSites);
  }

  get shouldShowFromToLocation(): boolean {
    if (this.consumer || this.SiteOnly || this.loginType === 'CO') return false;
    if (this.Date_Flat) {
      return this.selectedfiltersType === 'Date Wise';
    }
    return this.FromToLocation || (this.ShowLocationDropdown && !this.SingleLocationDropdown);
  }

  get shouldShowSingleLocation(): boolean {
    if (this.consumer || this.SiteOnly || this.Nolocation || this.loginType === 'CO') return false;
    if (this.Date_Flat) {
      return this.selectedfiltersType === 'Flat Wise';
    }
    return this.SingleLocationDropdown || (this.ShowLocationDropdown && this.SingleLocationDropdown);
  }

  get showDateFlatToggle(): boolean {
    return this.Date_Flat && !this.consumer && this.loginType !== 'CO';
  }

  get shouldShowDateRangePicker(): boolean {
    if (this.consumer) return false;
    if (this.Date_Flat) {
      return this.selectedfiltersType === 'Flat Wise';
    }
    const isExplicitTimeOrMonth = this.Date_Time || this.DateTimerange || this.Date_time || this.Month_Range || this.Month_Year || this.showSingleDate;
    return (this.showDaterange || this.loginType === 'CO') && !isExplicitTimeOrMonth;
  }

  get shouldShowSingleDatePicker(): boolean {
    if (this.consumer) return false;
    if (this.Date_Flat) {
      return this.selectedfiltersType === 'Date Wise';
    }
    return this.showSingleDate;
  }

  get showMonthRangePicker(): boolean {
    return !this.consumer && this.Month_Range;
  }

  get showDateTimeRangePicker(): boolean {
    return !this.consumer && (this.Date_Time || this.DateTimerange) && !this.Month_Range;
  }

  // ===============================
  // SITE RESOLUTION & DECODING
  // ===============================
  decodeSiteId(val: string | null | undefined): string {
    if (!val) return '';
    const trimmed = val.trim();
    try {
      const decoded = atob(trimmed);
      if (decoded) {
        return decoded.trim();
      }
    } catch { }
    return trimmed;
  }

  /**
   * Resolves the minimum selectable date from localStorage key 'app-filter-select'.
   * Safely handles null, undefined, empty string, or invalid date values.
   */
  resolveMinDate(): any {
    try {
      if (typeof localStorage === 'undefined') return undefined;
      const raw = localStorage.getItem('live_date');
      if (!raw) return undefined;

      let val = String(raw).trim();
      if (!val || val === 'null' || val === 'undefined' || val === 'NaN') {
        return undefined;
      }

      // Handle cases where string might be JSON-quoted or a JSON object
      if ((val.startsWith('"') && val.endsWith('"')) || (val.startsWith("'") && val.endsWith("'"))) {
        val = val.slice(1, -1).trim();
      } else if (val.startsWith('{') && val.endsWith('}')) {
        try {
          const parsed = JSON.parse(val);
          val = String(parsed?.date || parsed?.minDate || parsed?.value || val).trim();
        } catch {
          // ignore JSON parse error
        }
      }

      if (!val || val === 'null' || val === 'undefined') {
        return undefined;
      }

      // If it matches YYYY-MM-DD format, construct a local midnight Date to avoid UTC timezone day shifts
      if (/^\d{4}-\d{2}-\d{2}$/.test(val)) {
        const [year, month, day] = val.split('-').map(Number);
        const dateObj = new Date(year, month - 1, day, 0, 0, 0, 0);
        console.log(dateObj);

        return !isNaN(dateObj.getTime()) ? dateObj : undefined;
      }

      const timestamp = Date.parse(val);
      if (isNaN(timestamp)) {
        return undefined;
      }

      const dateObj = new Date(val);
      return !isNaN(dateObj.getTime()) ? dateObj : undefined;
    } catch {
      return undefined;
    }
  }

  private resolveSiteContext(): void {
    const rawParam =
      this.route.snapshot.queryParamMap.get('siteid') ||
      this.route.snapshot.queryParamMap.get('site_id');
    const rawLogin =
      localStorage.getItem('site_idLogin') ||
      localStorage.getItem('siteId') ||
      localStorage.getItem('site_id');
    const candidate = rawParam || rawLogin;

    if (candidate) {
      this.siteid = this.decodeSiteId(candidate);
    } else {
      this.siteid = null;
    }

    if (this.isSingleSite) {
      this.lockedSiteName = this.resolveLockedSiteName(this.siteid || '');
      if (!this.SiteOnly && this.loginType !== 'CO') {
        if (this.isTowerSelect) {
          this.getTowerList(this.siteid);
        } else {
          this.getLocationList(this.siteid);
        }
      }
      if (this.showappliances) {
        this.getApplicanceList(this.siteid || '');
      }
    }
  }

  private resolveLockedSiteName(siteId: string = ''): string {
    try {
      const storedSites = localStorage.getItem('siteList');
      if (!storedSites) return 'Selected Site';
      const parsed = JSON.parse(storedSites);
      const siteList = Array.isArray(parsed) ? parsed : parsed?.Data?.list || [];
      return siteList.find((s: any) => String(s.site_id) === String(siteId))?.site_name || 'Selected Site';
    } catch {
      return 'Selected Site';
    }
  }

  getEffectiveSiteId(): string | null {
    if (this.selectedSite?.site_id && this.selectedSite.site_id !== 'ALL' && this.selectedSite.site_id !== 'all') {
      return this.decodeSiteId(String(this.selectedSite.site_id));
    }
    if (this.siteid && this.siteid !== 'ALL' && this.siteid !== 'all') {
      return this.decodeSiteId(String(this.siteid));
    }
    const querySite = this.route.snapshot.queryParamMap.get('siteid') || this.route.snapshot.queryParamMap.get('site_id');
    if (querySite) {
      const decoded = this.decodeSiteId(querySite);
      if (decoded && decoded !== 'ALL' && decoded !== 'all') return decoded;
    }
    const rawStorageSite =
      localStorage.getItem('site_idLogin') ||
      localStorage.getItem('siteId') ||
      localStorage.getItem('site_id') ||
      sessionStorage.getItem('consumerSiteId');
    if (rawStorageSite) {
      const decoded = this.decodeSiteId(rawStorageSite);
      if (decoded && decoded !== 'ALL' && decoded !== 'all') return decoded;
    }
    return null;
  }

  private configureGenericDropdown(): void {
    if (this.dropdownOptions) {
      const keys = Object.keys(this.dropdownOptions).filter(k => k !== 'required');
      this.dropdownKey = keys[0];
      this.dropdownList = this.dropdownOptions[this.dropdownKey] || [];
      this.dropdownRequired = this.dropdownOptions.required || false;
    }
  }

  getSelectedSubtypeIcon(): string {
    const matched = this.subtype?.item?.find((i: any) => i.name === this.selectedItem || i.id === this.selectedItemId);
    return matched?.icon || matched?.image || '';
  }

  private configureSubtypeOptions(): void {
    this.subtype.item =
      this.loginType === 'CO'
        ? this.dropdownItems
        : [
          { id: 'CB', name: 'CB', icon: 'assets/DashboardIcon/CB.png' },
          { id: 'Datalogger', name: 'Gateway', icon: 'assets/DashboardIcon/DL.png' },
          { id: 'Sensor', name: 'Meter', icon: 'assets/DashboardIcon/sensor.png' }
        ];

    if (this.subtype?.item?.length) {
      this.selectedItem = this.subtype.item[0].name;
    }
  }

  private loadInitialSiteData(): void {
    if (this.loginType !== 'CO' && !this.isSingleSite) {
      this.getsitelist();
    }
    this.updateFormattedDates();
  }

  // ===============================
  // SITE DATA & INTERACTION
  // ===============================
  getsitelist(): void {
    this.siteloading = true;
    const storedData = localStorage.getItem('siteList');

    this.apiservice.getSiteList().subscribe({
      next: (data) => {
        const siteList: DropdownItem[] = (data?.Data?.list || []).map((site: any) => ({
          ...site,
          selected: false
        }));

        if (storedData !== '') {
          localStorage.setItem('siteList', JSON.stringify(data?.Data?.list || []));
        }

        this.basicdropdownitem = [
          { site_name: this.AllSelection ? 'All' : 'Select All Sites', site_id: 'ALL', selected: false },
          ...siteList
        ];

        this.updateSelectAllState();
        this.siteloading = false;
        this.loadDynamicFilterOptions();
      },
      error: () => {
        this.siteloading = false;
      }
    });
  }

  selectSite(item: any): void {
    this.selectedSite = item;
    this.resetFilterSelections(false);

    if (this.isTowerSelect && this.selectedSite?.site_id) {
      this.getTowerList(this.selectedSite.site_id);
    } else if (!this.SiteOnly && this.selectedSite?.site_id) {
      this.getLocationList(this.selectedSite.site_id);
    }
    if (this.showappliances && this.selectedSite?.site_id) {
      this.getApplicanceList(this.selectedSite.site_id);
    }
    this.loadDynamicFilterOptions();
  }

  onItemSelectionChange(changedItem: DropdownItem): void {
    this.resetFilterSelections(false);

    const isAllLabel = changedItem.site_name === 'All' || changedItem.site_name === 'Select All Sites';
    if (isAllLabel) {
      const isSelected = changedItem.selected;
      this.basicdropdownitem
        .filter(item => item.site_name !== 'All' && item.site_name !== 'Select All Sites')
        .forEach(item => (item.selected = isSelected));
    }

    this.updateSelectAllState();

    const selectedSites = this.basicdropdownitem.filter(
      item => item.site_name !== 'All' && item.site_name !== 'Select All Sites' && item.selected
    );

    if (selectedSites.length === 1 && !this.SiteOnly) {
      if (this.isTowerSelect) {
        this.getTowerList(selectedSites[0].site_id);
      } else {
        this.getLocationList(selectedSites[0].site_id);
      }
    } else {
      this.towerList = [];
      this.selectedTower = null;
      this.resetLocationData();
    }

    this.loadDynamicFilterOptions();
  }

  updateSelectAllState(): void {
    if (!this.basicdropdownitem?.length) return;
    const selectAllItem = this.basicdropdownitem.find(item => item.site_name === 'All' || item.site_name === 'Select All Sites');
    if (selectAllItem) {
      const otherItems = this.basicdropdownitem.filter(item => item.site_name !== 'All' && item.site_name !== 'Select All Sites');
      selectAllItem.selected = otherItems.length > 0 && otherItems.every(item => item.selected);
    }
  }

  get selectedItemsCount(): number {
    return this.basicdropdownitem.filter(item => item.selected && item.site_name !== 'All' && item.site_name !== 'Select All Sites').length;
  }

  getSelectedSiteNames(): string {
    return this.dropdownButtonText;
  }

  get filteredItems(): DropdownItem[] {
    const selectAllItem = this.basicdropdownitem.find(item => item.site_name === 'All' || item.site_name === 'Select All Sites');
    let displayableItems = this.basicdropdownitem.filter(item => item.site_name !== 'All' && item.site_name !== 'Select All Sites');

    if (this.searchTerm?.trim()) {
      const lower = this.searchTerm.toLowerCase();
      displayableItems = displayableItems.filter(item =>
        item.site_name.toLowerCase().includes(lower)
      );
    }

    displayableItems.sort((a, b) => {
      if (a.selected && !b.selected) return -1;
      if (!a.selected && b.selected) return 1;
      return 0;
    });

    return selectAllItem ? [selectAllItem, ...displayableItems] : displayableItems;
  }

  shouldShowNoSitesFound(): boolean {
    if (!this.basicdropdownitem?.length || !this.searchTerm?.trim()) return false;
    const term = this.searchTerm.trim().toLowerCase();
    return !this.basicdropdownitem
      .filter(item => item.site_name !== 'All' && item.site_name !== 'Select All Sites')
      .some(it => it.site_name.toLowerCase().includes(term));
  }

  shouldShowNoSitesAvailable(): boolean {
    if (!this.basicdropdownitem) return true;
    return !this.searchTerm && this.basicdropdownitem.filter(it => it.site_name !== 'All' && it.site_name !== 'Select All Sites').length === 0;
  }

  handleItemClick(event: MouseEvent): void {
    event.stopPropagation();
  }

  // ===============================
  // TOWER & LOCATION & APPLIANCES
  // ===============================
  get filteredTowers(): TowerItem[] {
    if (!this.towerSearchTerm?.trim()) return this.towerList;
    const term = this.towerSearchTerm.toLowerCase();
    return this.towerList.filter(tower => (tower.name ?? '').toLowerCase().includes(term));
  }

  getTowerList(siteid: string | null = ''): void {
    const site_id = siteid ?? '';
    if (!site_id || site_id === 'ALL' || site_id === 'all') {
      this.towerList = [];
      this.selectedTower = null;
      this.resetLocationData();
      return;
    }

    this.apiservice.towerlist(site_id).subscribe({
      next: (res: any) => {
        if (!res || res?.Status === 'Error' || res?.Message === 'No Data' || !Array.isArray(res?.Data) || res?.Data?.length === 0) {
          this.towerList = [];
          this.selectedTower = null;
          this.resetLocationData();
          return;
        }

        let data: any[] = [];
        if (this.AllSelection) {
          data = [{ id: 'ALL', name: 'All Towers' }, ...(res?.Data || [])];
        } else {
          data = res?.Data || [];
        }
        this.towerList = data;

        if (this.AllSelection) {
          const allOption = data.find(d => d.id === 'ALL') || null;
          this.selectedTower = allOption;
          this.getLocationList(site_id, '');
        } else {
          this.selectedTower = null;
        }
      },
      error: () => {
        this.towerList = [];
        this.selectedTower = null;
        this.resetLocationData();
      }
    });
  }

  selectTower(tower: TowerItem): void {
    this.selectedTower = tower;
    this.resetLocationData();
    const effectiveSite = this.getEffectiveSiteId() || (this.siteid && this.siteid !== 'ALL' ? this.siteid : '');
    if (effectiveSite) {
      const towerIdToSend = (tower?.id && tower.id !== 'ALL') ? tower.id : '';
      this.getLocationList(effectiveSite, towerIdToSend);
    }
  }

  private resetLocationData(): void {
    this.selectedLocationIds = [];
    this.selectedLocationIdsFrom = [];
    this.selectedLocationIdsTo = [];
    this.selectedLocation = null;
    this.selectedLocationFrom = null;
    this.selectedLocationTo = null;
    this.locationFrom = '';
    this.locationTo = '';
    this.locationSingle = '';
    this.locationSearchTerm = '';
    this.locationSearchTermFrom = '';
    this.locationSearchTermTo = '';
  }

  getLocationList(siteid: string | null = '', tower_id: string = ''): void {
    const site_id = siteid ?? '';
    if (!site_id || site_id === 'ALL' || site_id === 'all') {
      this.resetLocationData();
      return;
    }

    const towerIdToSend = (tower_id && tower_id !== 'ALL')
      ? tower_id
      : (this.isTowerSelect && this.selectedTower?.id && this.selectedTower.id !== 'ALL' ? this.selectedTower.id : '');

    this.apiservice.getLocationList(site_id, towerIdToSend).subscribe({
      next: (res: any) => {
        if (!res || res?.Status === 'Error' || res?.Message === 'No Data' || !Array.isArray(res?.Data) || res?.Data?.length === 0) {
          this.resetLocationData();
          return;
        }

        let data: any[] = [];
        if (this.AllSelection) {
          data = [{ id: 'ALL', location_no: 'All Units' }, ...(res?.Data || [])];
        } else {
          data = res?.Data || [];
        }

        this.selectedLocationIds = data;
        this.selectedLocationIdsFrom = data;
        this.selectedLocationIdsTo = data;

        if (this.AllSelection) {
          const allOption = data.find(d => d.id === 'ALL') || null;
          this.selectedLocation = this.SingleLocationDropdown ? allOption : null;
          this.selectedLocationFrom = allOption;
          this.selectedLocationTo = allOption;
          this.locationFrom = allOption ? allOption.id : 'ALL';
          this.locationTo = allOption ? allOption.id : 'ALL';
          this.locationSingle = (this.SingleLocationDropdown && allOption) ? allOption.id : 'ALL';
        } else {
          this.selectedLocation = null;
          this.selectedLocationFrom = null;
          this.selectedLocationTo = null;
          this.locationFrom = '';
          this.locationTo = '';
          this.locationSingle = '';
        }
      },
      error: () => {
        this.resetLocationData();
      }
    });
  }

  get filteredLocations(): LocationItem[] {
    return this.filterLocations(this.selectedLocationIds, this.locationSearchTerm);
  }

  get filteredLocationsFrom(): LocationItem[] {
    return this.filterLocations(this.selectedLocationIdsFrom, this.locationSearchTermFrom);
  }

  get filteredLocationsTo(): LocationItem[] {
    return this.filterLocations(this.selectedLocationIdsTo, this.locationSearchTermTo);
  }

  private filterLocations(list: LocationItem[], searchTerm: string): LocationItem[] {
    if (!searchTerm?.trim()) return list;
    const term = searchTerm.toLowerCase();
    return list.filter(loc => (loc.location_no ?? '').toLowerCase().includes(term));
  }

  onlocationSelectFrom(location: LocationItem): void {
    this.selectedLocationFrom = location;
    this.locationFrom = location.id;

    if (location?.id === 'ALL') {
      this.selectedLocationTo = location;
      this.locationTo = location.id;
    }
  }

  onlocationSelectTo(location: LocationItem): void {
    this.selectedLocationTo = location;
    this.locationTo = location.id;
  }

  onlocationSelectsingle(location: LocationItem, type: string = 'Id'): void {
    this.selectedLocation = location;
    if (type === 'name') {
      this.locationNo = location.location_no;
    } else {
      this.locationSingle = location.id;
    }
  }

  onlocationSelect(event: any): void {
    if (event?.id) {
      this.selectedLocation = event;
      this.ConsumerLocationId = event.id;
    } else if (event?.target) {
      this.ConsumerLocationId = event.target.value;
    }
  }

  getApplicanceList(site_id: string = ''): void {
    const cleanSite = this.decodeSiteId(site_id);
    if (!cleanSite || cleanSite === 'ALL') return;

    this.apiservice.getApplianceList(cleanSite).subscribe(res => {
      const data: any[] = this.AllSelection
        ? [{ id: 'ALL', name: 'All Appliances' }, ...(res?.Data || [])]
        : res?.Data || [];

      this.selectedAppliances = data;
      this.selectedItemAppliance = 'All Appliances';
    });
  }

  OnApplianceSelect(item: { id: string; name: string }): void {
    this.selectedItemAppliance = item.name;
    this.selectedApplianceId = item.id;
  }

  // ===============================
  // DYNAMIC FILTERS (filterConfig)
  // ===============================
  loadDynamicFilterOptions(force: boolean = false): void {
    if (!this.filterConfig?.length) return;
    const effectiveSiteId = this.getEffectiveSiteId() || '';

    this.filterConfig.forEach(field => {
      const key = field.apiKey || field.key;
      if (field.type === 'text' && key && this.dynamicSelectedMap[key]?.value !== undefined) {
        field.value = this.dynamicSelectedMap[key].value;
      }
      if (!field.apiUrl) return;

      // If this dynamic field explicitly requires a site, but no site is selected/available yet
      if (field.requiresSite && !effectiveSiteId) {
        const placeholder = field.placeholder || field.label || 'Select';
        field.options = [{ label: placeholder, value: '' }];
        field._lastLoadedKey = '';
        return;
      }

      const staticPayload = field.StaticPayload || field.staticPayload;
      const currentKey = `${field.apiUrl}_site:${effectiveSiteId}_${JSON.stringify(staticPayload || {})}`;

      // Prevent duplicate fetches if options are already loaded for the current site & payload
      if (!force && field._lastLoadedKey === currentKey && field.options && field.options.length > 0) {
        return;
      }

      // Prevent duplicate in-flight requests for the exact same key
      if (!force && field._loadingKey === currentKey) {
        return;
      }

      field._loadingKey = currentKey;

      let params = new HttpParams();
      if (effectiveSiteId) {
        params = params.set('site_id', effectiveSiteId);
      }

      if (staticPayload && typeof staticPayload === 'object') {
        Object.keys(staticPayload).forEach(k => {
          if (staticPayload[k] !== undefined && staticPayload[k] !== null) {
            params = params.set(k, String(staticPayload[k]));
          }
        });
      }

      const cleanUrl = field.apiUrl.replace(/^\/+/, '');
      this.http.get<any>(`${environment.apiURL}/${cleanUrl}`, { params }).subscribe({
        next: (res: any) => {
          field._loadingKey = '';
          field._lastLoadedKey = currentKey;

          const list = res?.Data?.list || res?.Data || (Array.isArray(res) ? res : []);
          const placeholder = field.placeholder || field.label || 'Select';
          const valueKey = field.valueKey || 'id';
          const labelKey = field.labelKey || 'name';
          const mappedOptions = (Array.isArray(list) ? list : []).map((item: any) => {
            const val = (field.valueKey && item[field.valueKey] !== undefined)
              ? item[field.valueKey]
              : (item.dic_id ?? item.id ?? item.cb_id ?? item.value ?? item.key ?? (item[valueKey] ?? ''));
            const lbl = (field.labelKey && item[field.labelKey] !== undefined)
              ? item[field.labelKey]
              : (item.name ?? item.cb_name ?? item.title ?? item.dic_name ?? item.label ?? (item[labelKey] ?? (val !== undefined && val !== null && val !== '' ? String(val) : '')));
            return {
              label: lbl,
              value: val
            };
          });

          field.options = [
            { label: placeholder, value: '' },
            ...mappedOptions
          ];

          const key = field.apiKey || field.key;
          const currentVal = (key && this.dynamicSelectedMap[key]?.value !== undefined) ? this.dynamicSelectedMap[key].value : field.value;
          if (currentVal !== undefined && currentVal !== null && currentVal !== '' && mappedOptions.some((opt: any) => String(opt.value) === String(currentVal))) {
            field.value = currentVal;
            const matchingOpt = mappedOptions.find((opt: any) => String(opt.value) === String(currentVal));
            if (matchingOpt) {
              field.selectedOption = matchingOpt;
              if (key) {
                this.dynamicSelectedMap[key] = {
                  value: currentVal,
                  label: matchingOpt.label || (matchingOpt as any).name || String(currentVal),
                  option: matchingOpt
                };
              }
            }
          } else if (field.value && !mappedOptions.some((opt: any) => String(opt.value) === String(field.value))) {
            field.value = '';
            if (key) delete this.dynamicSelectedMap[key];
          }
        },
        error: (err) => {
          field._loadingKey = '';
          console.error(`Failed to load options for ${field.apiKey} from ${field.apiUrl}`, err);
        }
      });
    });
  }

  getSelectedOptionLabel(field: any): string {
    const key = field?.apiKey || field?.key;
    if (key && this.dynamicSelectedMap[key]) {
      const mapped = this.dynamicSelectedMap[key];
      if (mapped.label !== undefined && mapped.label !== null && mapped.label !== '') {
        if (field.value !== mapped.value) {
          field.value = mapped.value;
        }
        if (!field.selectedOption) {
          field.selectedOption = mapped.option;
        }
        return mapped.label;
      }
    }
    if (field?.selectedOption) {
      const lbl = field.selectedOption.label || field.selectedOption.name;
      if (lbl !== undefined && lbl !== null && lbl !== '') {
        if (key && !this.dynamicSelectedMap[key]) {
          this.dynamicSelectedMap[key] = { value: field.value, label: lbl, option: field.selectedOption };
        }
        return lbl;
      }
    }
    if (field?.value !== undefined && field?.value !== null && field?.value !== '') {
      const opt = field.options?.find((o: any) => {
        const val = o.value !== undefined ? o.value : o.id;
        return String(val) === String(field.value);
      });
      if (opt) {
        const lbl = opt.label || opt.name || (opt.value !== undefined ? String(opt.value) : '');
        if (key) {
          this.dynamicSelectedMap[key] = { value: field.value, label: lbl, option: opt };
        }
        field.selectedOption = opt;
        return lbl;
      }
    }
    return '';
  }

  getFilteredDynamicOptions(field: any): any[] {
    const options = field?.options || [];
    const term = (field?.searchTerm || '').trim().toLowerCase();
    if (!term) return options;
    return options.filter((opt: any) => {
      const lbl = opt?.label || opt?.name || '';
      const val = opt?.value !== undefined ? opt?.value : opt?.id;
      return lbl.toLowerCase().includes(term) || String(val ?? '').toLowerCase().includes(term);
    });
  }

  onSelectDynamicOption(field: any, option: any): void {
    const key = field.apiKey || field.key;
    const val = option.value !== undefined ? option.value : option.id;
    const lbl = option.label || option.name || (val !== undefined && val !== null ? String(val) : '');
    field.value = val;
    field.selectedOption = option;
    if (key) {
      this.dynamicSelectedMap[key] = { value: val, label: lbl, option };
    }
  }

  getApiPayload(): any {
    const payload: any = {};
    this.filterConfig?.forEach(field => {
      const key = field.apiKey || field.key;
      let val = field.value;
      if (key && this.dynamicSelectedMap[key]?.value !== undefined) {
        val = this.dynamicSelectedMap[key].value;
      }
      if (key && val !== null && val !== undefined && val !== '') {
        payload[key] = val;
        if (field.type === 'text') {
          this.dynamicSelectedMap[key] = { value: val, label: val, option: null };
        }
        const optLabel = this.dynamicSelectedMap[key]?.label || field.selectedOption?.label || field.selectedOption?.name;
        if (optLabel && val !== 'ALL') {
          const lowerKey = key.toLowerCase();
          if (lowerKey === 'loc_idfrom' || lowerKey === 'from_location_id' || lowerKey === 'loc_from') {
            payload.Unit_From = optLabel;
          } else if (lowerKey === 'loc_idto' || lowerKey === 'to_location_id' || lowerKey === 'loc_to') {
            payload.Unit_To = optLabel;
          } else if (lowerKey === 'location_id' || lowerKey === 'loc_id' || lowerKey === 'water_loc_id') {
            payload.Unit = optLabel;
          }
        }
      }
    });
    return payload;
  }

  // ===============================
  // DATE / TIME PARSING & FORMATTING
  // ===============================
  DailyReportHandler(): void {
    this.showTable.emit(false);
    this.aggrid.processTableData([]);
    this.resetFilterSelections(false);
  }

  updateFormattedDatesTime(): void {
    if (!this.fromDateTime || !this.toDateTime) {
      this.formattedFromDate = '';
      this.formattedToDate = '';
      return;
    }

    const from = this.fromDateTime instanceof Date ? this.fromDateTime : new Date(this.fromDateTime);
    const to = this.toDateTime instanceof Date ? this.toDateTime : new Date(this.toDateTime);

    if (isNaN(from.getTime()) || isNaN(to.getTime())) {
      this.formattedFromDate = '';
      this.formattedToDate = '';
      return;
    }

    if (from > to) {
      this.toast.showToast('From date cannot be after To date', 'colored', 3000, 'warning');
      return;
    }

    if (this.timeDuration && this.timeDuration > 0) {
      const diffInSeconds = (to.getTime() - from.getTime()) / 1000;
      if (diffInSeconds > this.timeDuration) {
        const hours = this.timeDuration / 3600;
        this.toast.showToast(`Please select time range within ${hours} hrs.`, 'colored', 3000, 'warning');
        return;
      }
    }

    this.formattedFromDate = this.formatIST(from);
    this.formattedToDate = this.formatIST(to);
  }

  updateFormattedMonthRange(): void {
    if (!this.fromDateTime || !this.toDateTime) {
      this.formattedFromDate = '';
      this.formattedToDate = '';
      return;
    }

    const from = this.fromDateTime instanceof Date ? this.fromDateTime : new Date(this.fromDateTime);
    const to = this.toDateTime instanceof Date ? this.toDateTime : new Date(this.toDateTime);

    if (isNaN(from.getTime()) || isNaN(to.getTime())) {
      this.formattedFromDate = '';
      this.formattedToDate = '';
      return;
    }

    if (from > to) {
      this.toast.showToast('From month cannot be after To month', 'colored', 3000, 'warning');
      return;
    }

    const formatMonthYear = (d: Date) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    this.formattedFromDate = formatMonthYear(from);
    this.formattedToDate = formatMonthYear(to);
  }

  private toHHMM(val: any): string {
    if (!val) return '';
    if (val instanceof Date) {
      return `${String(val.getHours()).padStart(2, '0')}:${String(val.getMinutes()).padStart(2, '0')}`;
    }
    return val.toString();
  }

  private formatDay(d: Date): string {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }

  private formatTime(d: Date): string {
    return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
  }

  updateDateTimeRange(changed: 'from' | 'to' = 'from'): void {
    if (!this.selectedDate) return;

    const baseDay = this.formatDay(new Date(this.selectedDate));
    const fromStr = this.toHHMM(this.fromDateTime);
    const toStr = this.toHHMM(this.toDateTime);

    if (this.Date_time && this.timeDuration > 0) {
      if (changed === 'from' && fromStr) {
        const fromDt = new Date(`${baseDay}T${fromStr}:00`);
        const toDt = new Date(fromDt.getTime() + this.timeDuration * 1000);

        this.toDateTime = this.formatTime(toDt);
        this.formattedFromDate = `${baseDay} ${fromStr}`;
        this.formattedToDate = `${this.formatDay(toDt)} ${this.toDateTime}`;
        return;
      }

      if (changed === 'to' && toStr) {
        const toDt = new Date(`${baseDay}T${toStr}:00`);
        const fromDt = new Date(toDt.getTime() - this.timeDuration * 1000);

        this.fromDateTime = this.formatTime(fromDt);
        this.formattedToDate = `${baseDay} ${toStr}`;
        this.formattedFromDate = `${this.formatDay(fromDt)} ${this.fromDateTime}`;
        return;
      }
    }

    if (!fromStr || !toStr) return;
    this.formattedFromDate = `${baseDay} ${fromStr}`;
    this.formattedToDate = `${baseDay} ${toStr}`;
  }

  formatIST(date: Date): string {
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
      `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  }

  updateFormattedDates(): void {
    const format = (d: Date) => d.toISOString().split('T')[0];

    if (typeof this.dateRange === 'string') {
      if (this.dateRange.includes(' to ')) {
        const [fromStr, toStr] = this.dateRange.split(' to ');
        const fromDate = new Date(fromStr);
        const toDate = new Date(toStr);

        if (!isNaN(fromDate.getTime())) {
          this.formattedFromDate = format(fromDate);
          this.formattedToDate = !isNaN(toDate.getTime()) ? format(toDate) : this.formattedFromDate;
          return;
        }
      }

      const singleDate = new Date(this.dateRange);
      if (!isNaN(singleDate.getTime())) {
        this.formattedFromDate = format(singleDate);
        this.formattedToDate = this.formattedFromDate;
        return;
      }
    }

    if (Array.isArray(this.dateRange)) {
      const fromDate = this.dateRange[0];
      const toDate = this.dateRange[1];

      if (fromDate instanceof Date && !isNaN(fromDate.getTime())) {
        this.formattedFromDate = format(fromDate);
        this.formattedToDate =
          toDate instanceof Date && !isNaN(toDate.getTime()) ? format(toDate) : this.formattedFromDate;
        return;
      }
    }

    this.formattedFromDate = '';
    this.formattedToDate = '';
  }

  updateFormattedDate(): void {
    let date: Date | null = null;
    if (this.selectedDate instanceof Date && !isNaN(this.selectedDate.getTime())) {
      date = this.selectedDate;
    } else if (typeof this.selectedDate === 'string') {
      const parsed = new Date(this.selectedDate);
      date = !isNaN(parsed.getTime()) ? parsed : null;
    }

    if (!date) {
      this.formattedDate = '';
      return;
    }

    const iso = date.toISOString().split('T')[0];
    this.formattedDate = this.Month_Year ? iso.slice(0, 7) : iso;
  }

  openCalendar(): void {
    this.flatpickr?.instance?.open();
  }

  openCalendarIndividual(picker: FlatpickrDirective): void {
    picker?.instance?.open();
  }

  onDropdownItemSelect(item: { id: string; name: string }): void {
    this.selectedItem = item.name;
    this.selectedItemId = item.id;
    if (this.selectedItem === 'Electricity Meter') {
      this.locationId = false;
    } else if (this.loginType === 'CO') {
      this.locationId = true;
    }
  }

  BillingNo(item: { id: string; name: string }): void {
    this.BillingItem = item.name;
    this.BillingItemId = item.id;
  }

  selecthour(hour: any): void {
    this.selectedHours = hour;
  }

  Selected(item: any): void {
    this.selectedDropdown = item;
  }

  // ===============================
  // RESET STATE
  // ===============================
  private resetFilterSelections(resetSite: boolean = true): void {
    this.dateRange = '';
    this.formattedFromDate = '';
    this.formattedToDate = '';
    this.selectedDate = '';
    this.formattedDate = '';
    this.fromDateTime = '';
    this.toDateTime = '';

    this.locationFrom = '';
    this.locationTo = '';
    this.locationSingle = '';
    this.selectedLocation = null;
    this.selectedLocationFrom = null;
    this.selectedLocationTo = null;
    this.locationSearchTerm = '';
    this.locationSearchTermFrom = '';
    this.locationSearchTermTo = '';
    this.ConsumerLocationId = '';
    this.locationNo = '';

    this.selectedAppliances = [];
    this.selectedItemAppliance = '';
    this.selectedApplianceId = '';

    this.searchText = '';
    this.selectedDropdown = null;
    this.selectedTower = null;
    this.towerSearchTerm = '';

    if (resetSite) {
      this.dynamicSelectedMap = {};
      this.filterConfig?.forEach(f => {
        f.value = '';
        f.selectedOption = null;
        f.searchTerm = '';
      });
      this.towerList = [];
      this.selectedSite = null;
      this.searchTerm = '';
      if (this.basicdropdownitem?.length) {
        this.basicdropdownitem.forEach(item => (item.selected = false));
        this.updateSelectAllState();
      }
    } else {
      // Partial reset (e.g. site changed): only reset fields dependent on site
      this.filterConfig?.forEach(f => {
        if (f.requiresSite || f.apiUrl) {
          const key = f.apiKey || f.key;
          if (key) delete this.dynamicSelectedMap[key];
          f.value = '';
          f.selectedOption = null;
          f.searchTerm = '';
        }
      });
    }
  }

  resetFilters(): void {
    this.aggrid.processTableData([]);
    this.resetFilterSelections(true);
    this.showTable.emit(false);
    this.consumerListing.emit({ filter: 'reset', id: '' });
  }

  // ===============================
  // VALIDATION & APPLY FILTERS
  // ===============================
  applyFilters(): void {
    if (this.consumer) {
      this.applyConsumerFilter();
      return;
    }

    if (this.shouldShowDateRangePicker) {
      this.updateFormattedDates();
      if (!this.formattedFromDate || !this.formattedToDate) {
        this.toast.showToast('Please select a valid date range.', 'colored', 3000, 'warning');
        return;
      }
    }

    if (this.shouldShowSingleDatePicker) {
      this.updateFormattedDate();
      if (!this.selectedDate) {
        this.toast.showToast('Please select a date.', 'colored', 3000, 'warning');
        return;
      }
    }

    if (this.Month_Range) {
      this.updateFormattedMonthRange();
      if (!this.formattedFromDate || !this.formattedToDate) {
        this.toast.showToast('Please select a valid month range.', 'colored', 3000, 'warning');
        return;
      }
    }

    if (this.Date_Time || this.DateTimerange) {
      this.updateFormattedDatesTime();
      if (!this.formattedFromDate || !this.formattedToDate) {
        this.toast.showToast('Please select a valid date and time.', 'colored', 3000, 'warning');
        return;
      }
    }

    if (this.showsubtype && !this.selectedItemId && this.loginType !== 'CO') {
      this.toast.showToast('Please select a subtype.', 'colored', 3000, 'warning');
      return;
    }

    if (this.showappliances && !this.selectedApplianceId && !this.AllSelection) {
      this.toast.showToast('Please select an appliance.', 'colored', 3000, 'warning');
      return;
    }

    const invalidDynamicField = this.filterConfig?.find(
      f => f.required && (f.value === null || f.value === '' || f.value === undefined)
    );
    if (invalidDynamicField) {
      this.toast.showToast(`Please select ${invalidDynamicField.placeholder || invalidDynamicField.label}`, 'colored', 3000, 'warning');
      return;
    }

    // Site Resolution
    let siteIds = '';
    if (this.shouldShowMultiSiteSelect) {
      const selectAll = this.basicdropdownitem.find(
        item => (item.site_name === 'All' || item.site_name === 'Select All Sites') && item.selected
      );

      if (selectAll) {
        siteIds = 'ALL';
      } else {
        const checkedSites = this.basicdropdownitem
          .filter(item => item.selected && item.site_name !== 'All' && item.site_name !== 'Select All Sites')
          .map(item => item.site_id);

        if (!checkedSites.length && this.siteid === 'ALL') {
          this.toast.showToast('Please select at least one site.', 'colored', 3000, 'warning');
          return;
        }
        siteIds = checkedSites.join(',');
      }
    }

    const effectiveSingleSite = this.getEffectiveSiteId();

    if (this.shouldShowSingleSiteSelect && !effectiveSingleSite) {
      this.toast.showToast('Please select a site.', 'colored', 3000, 'warning');
      return;
    }

    if (this.dropdown && this.dropdownRequired && !this.selectedDropdown) {
      this.toast.showToast(`Please select a ${this.dropdownKey}.`, 'colored', 3000, 'warning');
      return;
    }

    if (this.shouldShowFromToLocation && !this.AllSelection) {
      if (!this.locationFrom) {
        this.toast.showToast('Please select From Unit.', 'colored', 3000, 'warning');
        return;
      }
      if (!this.locationTo) {
        this.toast.showToast('Please select To Unit.', 'colored', 3000, 'warning');
        return;
      }
    }

    if (this.shouldShowSingleLocation && !this.locationSingle && !this.AllSelection && this.loginType !== 'CO') {
      this.toast.showToast('Please select a Unit.', 'colored', 3000, 'warning');
      return;
    }

    const isCO = this.loginType === 'CO';
    const coLocationId = localStorage.getItem('login_id') || '';
    const resolvedSiteId =
      siteIds ||
      effectiveSingleSite ||
      (this.siteid && this.siteid !== 'ALL' ? this.siteid : '') ||
      (isCO ? sessionStorage.getItem('consumerSiteId') || '' : '');

    const dynamicPayload = this.getApiPayload();

    const payload: any = {
      ...dynamicPayload
    };

    if (resolvedSiteId) {
      payload.site_ids = resolvedSiteId;
    }

    if (this.isTowerSelect && this.selectedTower?.id && this.selectedTower.id !== 'ALL') {
      payload.tower_id = this.selectedTower.id;
    }

    if (this.showsubtype && this.selectedItemId) {
      payload.subtype = this.selectedItemId;
    }

    if (this.Hours && this.selectedHours) {
      payload.hours = this.selectedHours;
    }

    const dateVal = this.formattedDate || (typeof this.selectedDate === 'string' ? this.selectedDate : '');
    if ((this.shouldShowSingleDatePicker || this.showSingleDate || this.Month_Year || this.Date_Flat) && (dateVal || this.selectedDate)) {
      const finalDate = this.formattedDate || (this.selectedDate instanceof Date ? this.selectedDate.toISOString().split('T')[0] : String(this.selectedDate));
      if (finalDate) {
        payload.date = finalDate;
        payload.selected_date = finalDate;
      }
    }

    if (this.showappliances && this.selectedApplianceId) {
      payload.appliance = this.selectedApplianceId;
    }

    if (this.shouldShowDateRangePicker || this.Date_Time || this.DateTimerange || this.Month_Range || this.Date_time) {
      if (this.formattedFromDate) payload.from_date = this.formattedFromDate;
      if (this.formattedToDate) payload.to_date = this.formattedToDate;
    }

    if (this.search && this.searchText) {
      payload.search = this.searchText;
    }

    if (isCO) {
      if (coLocationId) payload.loc_id = coLocationId;
      if (this.selectedItemId) payload.otherType = this.selectedItemId;
      if (this.locationSingle && this.locationSingle !== 'ALL') {
        payload.water_loc_id = this.locationSingle;
        const loc = this.selectedLocation || this.selectedLocationIds.find(l => String(l.id) === String(this.locationSingle));
        if (loc?.location_no && loc.id !== 'ALL') {
          payload.Unit = loc.location_no;
        }
      }
    } else {
      if (this.shouldShowSingleLocation && this.locationSingle && this.locationSingle !== 'ALL') {
        payload.loc_id = this.locationSingle;
        payload.location_id = this.locationSingle;
        const loc = this.selectedLocation || this.selectedLocationIds.find(l => String(l.id) === String(this.locationSingle));
        if (loc?.location_no && loc.id !== 'ALL') {
          payload.Unit = loc.location_no;
        }
      } else if (this.ConsumerLocationId && this.ConsumerLocationId !== 'ALL') {
        payload.loc_id = this.ConsumerLocationId;
        payload.location_id = this.ConsumerLocationId;
        const loc = this.selectedLocation || this.selectedLocationIds.find(l => String(l.id) === String(this.ConsumerLocationId));
        if (loc?.location_no && loc.id !== 'ALL') {
          payload.Unit = loc.location_no;
        }
      }
    }

    if (this.dropdown && this.selectedDropdown?.id) {
      payload[this.dropdownKey] = this.selectedDropdown.id;
    }

    if (this.shouldShowFromToLocation && !isCO) {
      if (this.locationFrom && this.locationFrom !== 'ALL') {
        payload.loc_from = this.locationFrom;
        payload.loc_idFrom = this.locationFrom;
        payload.from_location_id = this.locationFrom;
        const locFrom = this.selectedLocationFrom || this.selectedLocationIdsFrom.find(l => String(l.id) === String(this.locationFrom));
        if (locFrom?.location_no && locFrom.id !== 'ALL') {
          payload.Unit_From = locFrom.location_no;
        }
      }
      if (this.locationTo && this.locationTo !== 'ALL') {
        payload.loc_to = this.locationTo;
        payload.loc_idTo = this.locationTo;
        payload.to_location_id = this.locationTo;
        const locTo = this.selectedLocationTo || this.selectedLocationIdsTo.find(l => String(l.id) === String(this.locationTo));
        if (locTo?.location_no && locTo.id !== 'ALL') {
          payload.Unit_To = locTo.location_no;
        }
      }
    }

    if (this.showBillNo && this.BillingItemId) {
      payload.billing_no = this.BillingItemId;
    }

    // Final cleanup sweep to ensure no empty, null, or undefined keys are emitted
    Object.keys(payload).forEach(key => {
      const val = payload[key];
      if (val === undefined || val === null || val === '') {
        delete payload[key];
      }
    });

    this.filtersApplied.emit(payload);
  }

  onSelectedTypeChange(): void {
    this.locationNo = '';
    this.locationSearchTerm = '';
  }

  private applyConsumerFilter(): void {
    if (!this.locationNo) {
      this.toast.showToast('Please enter a location number.', 'colored', 3000, 'warning');
      return;
    }

    this.consumerListing.emit({
      filter: this.selectedType,
      id: this.locationNo
    });
  }
}
